import React from 'react';
import { i18n } from 'config/locales';
import SummaryProgress from 'components/Section/History/SummaryProgress';
import SvgComponent from 'components/Form/SvgComponent';
import { DateModel } from 'forms/shared/types';
import { isPVQForm } from 'helpers/form';

interface Props {
  dates: any[];
  years: number;
  applicantBirthdate: DateModel;
  thresholdYears: number;
}

const EmploymentSummaryProgress: React.FC<Props> = function ({
  dates, years, applicantBirthdate, thresholdYears, formType
}) {
  const isPvq = isPVQForm(formType);
  return isPvq ? (
    <SummaryProgress
      className="employment"
      List={() => dates}
      title={i18n.t('history.pvq.employment.summary.title')}
      unit={i18n.t('history.pvq.employment.summary.unit')}
      total={years}
      applicantBirthdate={applicantBirthdate}
      thresholdYears={thresholdYears}
    >
      <div className="summary-icon">
        <SvgComponent src="/img/employer-briefcase.svg" alt={i18n.t('history.pvq.employment.summary.svgAlt')} />
      </div>
    </SummaryProgress>
  )
    : (
      <SummaryProgress
        className="employment"
        List={() => dates}
        title={i18n.t('history.employment.summary.title')}
        unit={i18n.t('history.employment.summary.unit')}
        total={years}
        applicantBirthdate={applicantBirthdate}
        thresholdYears={thresholdYears}
      >
        <div className="summary-icon">
          <SvgComponent src="/img/employer-briefcase.svg" alt={i18n.t('history.employment.summary.svgAlt')} />
        </div>
      </SummaryProgress>
    );
};

EmploymentSummaryProgress.defaultProps = {
  years: 10,
  dates: [],
};

export default EmploymentSummaryProgress;
